export default __webpack_public_path__ + "static/media/notification-in-circle.4c424813.svg";